import { jsxs as D, jsx as e } from "react/jsx-runtime";
import b from "classnames";
import u from "./index.es5642.js";
import { SimpleTooltip as A } from "./index.es120.js";
import { BodyText as v } from "./index.es487.js";
import { Icon as U } from "./index.es147.js";
const k = ({
  label: c,
  testId: x = "colored-cell",
  color: s = "primary",
  additionalInfo: r,
  addArrowIndication: N
}) => {
  var h, l, w, i;
  const T = !isNaN(Number(c)), y = b(u.coloredCellRoot, { [u.numeric]: T }), t = s === "success", C = (t || s === "error") && N, p = (h = r == null ? void 0 : r.left) == null ? void 0 : h.tooltip, m = (l = r == null ? void 0 : r.left) == null ? void 0 : l.trigger, o = (w = r == null ? void 0 : r.right) == null ? void 0 : w.tooltip, g = (i = r == null ? void 0 : r.right) == null ? void 0 : i.trigger;
  return /* @__PURE__ */ D("div", { className: y, children: [
    m && /* @__PURE__ */ e(A, { title: p, isActive: !!p, children: /* @__PURE__ */ e("span", { tabIndex: 0, children: m }) }),
    /* @__PURE__ */ e(v, { color: s, element: "p", isEllipsis: !0, "data-testid": x, children: c }),
    C && /* @__PURE__ */ e(
      U,
      {
        type: t ? "ArrowUp" : "ArrowDown",
        size: 16,
        color: s,
        testId: `icon-${t ? "ArrowUp" : "ArrowDown"}`,
        weight: "outline"
      }
    ),
    g && /* @__PURE__ */ e(A, { title: o, isActive: !!o, children: /* @__PURE__ */ e("span", { tabIndex: 0, children: g }) })
  ] });
};
export {
  k as ColoredCell
};
//# sourceMappingURL=index.es633.js.map
